var React = require('react');

function ChevronSquareUp (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48zm-23.52 287.51l-17 17a24 24 0 0 1-33.94 0L224 234.91 122.43 336.48a24 24 0 0 1-33.94 0l-17-17a24 24 0 0 1 0-33.94L207 150.06a24 24 0 0 1 33.94 0l135.54 135.51a24 24 0 0 1 0 33.94z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M71.52 285.57L207 150.06a24 24 0 0 1 33.94 0l135.54 135.51a24 24 0 0 1 0 33.94l-17 17a24 24 0 0 1-33.94 0L224 234.91 122.43 336.48a24 24 0 0 1-33.94 0l-17-17a24 24 0 0 1 .03-33.91z","className":"fa-primary","key":2})]);
}

ChevronSquareUp.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = ChevronSquareUp;

ChevronSquareUp.default = ChevronSquareUp;
